import { combineReducers } from 'redux';

import {
    ACTIONS_COUNT_LOADING,
    ACTIONS_COUNT_LOADED,
    DEALS_COUNT_LOADING,
    DEALS_COUNT_LOADED,
    DEBTS_STATUS_COUNT_LOADED,
    DEBTS_STATUS_COUNT_LOADING,
    NEXT_TRANSFER_LOADING,
    NEXT_TRANSFER_LOADED,
    PAYMENT_COUNT_LOADING,
    PAYMENT_COUNT_LOADED,
    PENDING_DEBTS_LOADING,
    PENDING_DEBTS_LOADED,
    SURVEYS_DASHBOARD_LOADED,
    SURVEYS_DASHBOARD_LOADING
} from 'modules/dashboard/actions/dashboard.action';

import {
    DEBTS_STARTED_CHARGES,
} from 'modules/company/actions/company.action';
import { AUTH_LOGOUT } from 'modules/auth/actions/authentication.action';

export const loadingActionsCount = (state = false, action) => {
    switch (action.type) {
        case ACTIONS_COUNT_LOADING:
            return action.payload;
        case ACTIONS_COUNT_LOADED:
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

export const actionsCountData = (state = null, action) => {
    switch (action.type) {
        case ACTIONS_COUNT_LOADED:
            return action.payload;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};


export const loadingDealsCount = (state = false, action) => {
    switch (action.type) {
        case DEALS_COUNT_LOADING:
            return action.payload;
        case DEALS_COUNT_LOADED:
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

export const dealsCountData = (state = null, action) => {
    switch (action.type) {
        case DEALS_COUNT_LOADED:
            return action.payload;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};


export const loadingDebtsStatusCount = (state = false, action) => {
    switch (action.type) {
        case DEBTS_STATUS_COUNT_LOADING:
            return action.payload;
        case DEBTS_STATUS_COUNT_LOADED:
            return false;
        default:
            return state;
    }
};

export const debtsStatusCountData = (state = null, action) => {
    switch (action.type) {
        case DEBTS_STATUS_COUNT_LOADED:
            return action.payload;
        default:
            return state;
    }
};

export const loadingNextTransfer = (state = false, action) => {
    switch (action.type) {
        case NEXT_TRANSFER_LOADING:
            return action.payload;
        case NEXT_TRANSFER_LOADED:
            return false;
        default:
            return state;
    }
};

export const nextTransfer = (state = null, action) => {
    switch (action.type) {
        case NEXT_TRANSFER_LOADED:
            return action.payload;
        default:
            return state;
    }
};

export const loadingPaymentCount = (state = false, action) => {
    switch (action.type) {
        case PAYMENT_COUNT_LOADING:
            return action.payload;
        case PAYMENT_COUNT_LOADED:
            return false;
        default:
            return state;
    }
};

export const paymentCount = (state = null, action) => {
    switch (action.type) {
        case PAYMENT_COUNT_LOADED:
            return action.payload;
        default:
            return state;
    }
};

export const loadingPendingDebts = (state = false, action) => {
    switch (action.type) {
        case PENDING_DEBTS_LOADING:
            return action.payload;
        case PENDING_DEBTS_LOADED:
            return false;
        default:
            return state;
    }
};

export const pendingDebts = (state = null, action) => {
    switch (action.type) {
        case PENDING_DEBTS_LOADED:
            return action.payload;
        case DEBTS_STARTED_CHARGES:
            return {
                amount: 0,
                total: 0,
            };
        default:
            return state;
    }
};

export const loadingSurveysDashboard = (state = false, action) => {
    switch (action.type) {
        case SURVEYS_DASHBOARD_LOADING:
            return action.payload;
        case SURVEYS_DASHBOARD_LOADED:
            return false;
        default:
            return state;
    }
};

export const surveysDashboard = (state = null, action) => {
    switch (action.type) {
        case SURVEYS_DASHBOARD_LOADED:
            return action.payload;
        default:
            return state;
    }
};

export default combineReducers({
    loadingActionsCount,
    actionsCountData,
    loadingDealsCount,
    dealsCountData,
    loadingDebtsStatusCount,
    debtsStatusCountData,
    loadingNextTransfer,
    nextTransfer,
    loadingPaymentCount,
    paymentCount,
    loadingPendingDebts,
    pendingDebts,
    loadingSurveysDashboard,
    surveysDashboard
});
